import React, { useEffect } from "react";
import Text from "../../../utils/Custom/text";
import { Autocomplete, TextField } from "@mui/material";
import { TextFields } from "../../../utils/Custom/custominput";
import { UploadButton } from "../../../utils/Custom/Button";
import { useParams } from "react-router-dom";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { toast } from "react-toastify";
import { CancelButton, SaveAndUpdate } from "../../../utils/Custom/Button";
import { BASE_URL } from "../../../global";
import { levelOptions, booleanOptions, BGASNACEoption, APIqualificationEoption, WeldingqualificationEoption, qmsAuditor } from "../../constants/inspectionOption";
import { getPermissions } from "../rbac/hasAccess";

const EditCAMMechanical = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const [inputStates, setInputStates] = React.useState({});
  const [usersList, setUsersList] = React.useState([]);
  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const getVal = (key) => inputStates[key] !== undefined && inputStates[key] !== null ? inputStates[key] : "";

  const handleFileUpload = (event, stateKey) => {
    const file = event.target.files[0];
    if (file && /[&#$*]/.test(file.name)) {
      toast.warning("File name contains special characters. Please rename the file and upload again.");
      return;
    }
    const data = new FormData();
    data.append("fileToUpload", file);
    axiosWithToken
      .post(BASE_URL + `fileUpload/fileUpload.php`, data)
      .then((res) => {
        if (res.status == 200) {
          updateInputObject(stateKey, res.data);
          toast.success("File Uploaded Successfully!");
        }
      })
      .catch(() => toast.error("Something went wrong"));
  };

  const onSubmit = () => {
    const url = BASE_URL + `cam_mechanical${params.id !== "0" ? `/${params.id}` : ""}`;
    const request =
      params.id !== "0"
        ? axiosWithToken.patch(url, inputStates)
        : axiosWithToken.post(url, inputStates);
    request
      .then(() => {
        toast.success(params.id !== "0" ? "Updated Successfully!" : "Created Successfully!");
        setTimeout(() => params.id !== "0" ? window.location.reload() : window.history.back(), 500);
      })
      .catch((error) => console.error("Submit error:", error));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const users = await fetchQuery(`SELECT user.*, emp.name, emp.location FROM users user LEFT JOIN employees emp ON user.employeeId = emp.id WHERE user.type = 2 AND user.status = 1`);
        setUsersList(users);

        if (params.id != 0) {
          const [cam_mechanical] = await fetchQuery(`SELECT * FROM cam_mechanical WHERE id = ${params.id}`);

          if (cam_mechanical) {
            const selectedUser = users.find((item) => item.id == cam_mechanical.userID);
            setInputStates({
              ...cam_mechanical,
              location: selectedUser?.location || "",
            });
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [params.id]);

  return (
    <div>
      <br />
      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {/* Name */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={usersList}
            getOptionLabel={(option) => `${option.name || ""} (${option.userName || ""})`}
            value={usersList.find((item) => item["id"] == getVal("userID")) || null}
            onChange={(event, value) => {
              updateInputObject("userID", value ? value.id : "");
              updateInputObject("location", value ? value.location : "");
            }}
            disabled={params.id != 0}
            renderInput={(params) => <TextField {...params} fullWidth label="Name" />}
          />
        </div>
        {/* Location */}
        <div className="w-full">
          <TextFields
            label="Location"
            value={getVal("location")}
            onChange={(e) => updateInputObject("location", e.target.value)}
            disabled={true}
          />
        </div>
        {/* Experience */}
        <div className="w-full">
          <TextFields
            label="Experience"
            value={getVal("experience")}
            onChange={(e) => updateInputObject("experience", e.target.value)}
          />
        </div>
        {/* Qualification */}
        <div className="w-full">
          <TextFields
            label="Qualification"
            value={getVal("qualification")}
            onChange={(e) => updateInputObject("qualification", e.target.value)}
          />
        </div>
        {/* Heading */}
        <div className="col-span-full">
          <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3">NDE Qualifications</Text>
        </div>
        {/* LPT */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={levelOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={levelOptions.find((item) => item["label"] == getVal("ndePlt")) || null}
            onChange={(event, value) => updateInputObject("ndePlt", value ? value["label"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="LPT" />}
          />
        </div>
        {/* LPT File */}
        <div className="w-full">
          <UploadButton
            label="LPT File"
            onChange={(e) => handleFileUpload(e, "lptFile")}
            outline={false}
            fileUrl={getVal("lptFile")}
            showFile={true}
            onRemove={() => updateInputObject("lptFile", null)}
          />
        </div>
        {/* RT */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={levelOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={levelOptions.find((item) => item["label"] == getVal("ndeRt")) || null}
            onChange={(event, value) => updateInputObject("ndeRt", value ? value["label"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="RT" />}
          />
        </div>
        {/* RT File */}
        <div className="w-full">
          <UploadButton
            label="RT File"
            onChange={(e) => handleFileUpload(e, "rtFile")}
            outline={false}
            fileUrl={getVal("rtFile")}
            showFile={true}
            onRemove={() => updateInputObject("rtFile", null)}
          />
        </div>
        {/* UT */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={levelOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={levelOptions.find((item) => item["label"] == getVal("ndeUt")) || null}
            onChange={(event, value) => updateInputObject("ndeUt", value ? value["label"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="UT" />}
          />
        </div>
        {/* UT File */}
        <div className="w-full">
          <UploadButton
            label="UT File"
            onChange={(e) => handleFileUpload(e, "utFile")}
            outline={false}
            fileUrl={getVal("utFile")}
            showFile={true}
            onRemove={() => updateInputObject("utFile", null)}
          />
        </div>
        {/* MPT */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={levelOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={levelOptions.find((item) => item["label"] == getVal("ndeMpt")) || null}
            onChange={(event, value) => updateInputObject("ndeMpt", value ? value["label"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="MPT" />}
          />
        </div>
        {/* MPT File */}
        <div className="w-full">
          <UploadButton
            label="MPT File"
            onChange={(e) => handleFileUpload(e, "mptFile")}
            outline={false}
            fileUrl={getVal("mptFile")}
            showFile={true}
            onRemove={() => updateInputObject("mptFile", null)}
          />
        </div>
        {/* VT */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={levelOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={levelOptions.find((item) => item["label"] == getVal("ndeVt")) || null}
            onChange={(event, value) => updateInputObject("ndeVt", value ? value["label"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="VT" />}
          />
        </div>
        {/* VT File */}
        <div className="w-full">
          <UploadButton
            label="VT File"
            onChange={(e) => handleFileUpload(e, "vtFIle")}
            outline={false}
            fileUrl={getVal("vtFIle")}
            showFile={true}
            onRemove={() => updateInputObject("vtFIle", null)}
          />
        </div>
        {/* FET */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={levelOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={levelOptions.find((item) => item["label"] == getVal("ndeFet")) || null}
            onChange={(event, value) => updateInputObject("ndeFet", value ? value["label"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="FET" />}
          />
        </div>
        {/* FET File */}
        <div className="w-full">
          <UploadButton
            label="FET File"
            onChange={(e) => handleFileUpload(e, "fetFile")}
            outline={false}
            fileUrl={getVal("fetFile")}
            showFile={true}
            onRemove={() => updateInputObject("fetFile", null)}
          />
        </div>
        {/* Heading */}
        <div className="col-span-full">
          <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3">Painting Qualifications</Text>
        </div>
        {/* BGAS/NACE */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={BGASNACEoption}
            getOptionLabel={(option) => option["label"] || ""}
            value={BGASNACEoption.find((item) => item["label"] == getVal("bgas")) || null}
            onChange={(event, value) => updateInputObject("bgas", value ? value["label"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="BGAS/ NACE" />}
          />
        </div>
        {/* BGAS File */}
        <div className="w-full">
          <UploadButton
            label="BGAS/ NACE File"
            onChange={(e) => handleFileUpload(e, "bgasFile")}
            outline={false}
            fileUrl={getVal("bgasFile")}
            showFile={true}
            onRemove={() => updateInputObject("bgasFile", null)}
          />
        </div>
        {/* Heading */}
        <div className="col-span-full">
          <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3">API Qualifications</Text>
        </div>
        {/* API */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={APIqualificationEoption}
            getOptionLabel={(option) => option["label"] || ""}
            value={APIqualificationEoption.find((item) => item["label"] == getVal("api")) || null}
            onChange={(event, value) => updateInputObject("api", value ? value["label"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="API" />}
          />
        </div>
        {/* API File */}
        <div className="w-full">
          <UploadButton
            label="API File"
            onChange={(e) => handleFileUpload(e, "apiFile")}
            outline={false}
            fileUrl={getVal("apiFile")}
            showFile={true}
            onRemove={() => updateInputObject("apiFile", null)}
          />
        </div>
        {/* Heading */}
        <div className="col-span-full">
          <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3">Welding Qualifications</Text>
        </div>
        {/* Welding */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={WeldingqualificationEoption}
            getOptionLabel={(option) => option["label"] || ""}
            value={WeldingqualificationEoption.find((item) => item["label"] == getVal("welding")) || null}
            onChange={(event, value) => updateInputObject("welding", value ? value["label"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="WELDING" />}
          />
        </div>
        {/* Welding File */}
        <div className="w-full">
          <UploadButton
            label="Welding File"
            onChange={(e) => handleFileUpload(e, "weldingFile")}
            outline={false}
            fileUrl={getVal("weldingFile")}
            showFile={true}
            onRemove={() => updateInputObject("weldingFile", null)}
          />
        </div>
        {/* Heading */}
        <div className="col-span-full">
          <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3">BASIC METALS</Text>
        </div>
        {/* Plates */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("metalPlates")) || null}
            onChange={(event, value) => updateInputObject("metalPlates", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Plates" />}
          />
        </div>
        {/* Pipes */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("metalPipe")) || null}
            onChange={(event, value) => updateInputObject("metalPipe", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Pipes" />}
          />
        </div>
        {/* Line Pipe */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("metalLinePipe")) || null}
            onChange={(event, value) => updateInputObject("metalLinePipe", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Line Pipe" />}
          />
        </div>
        {/* Flanges */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("metalFlanges")) || null}
            onChange={(event, value) => updateInputObject("metalFlanges", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Flanges" />}
          />
        </div>
        {/* Fittings */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("metalFittings")) || null}
            onChange={(event, value) => updateInputObject("metalFittings", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Fittings" />}
          />
        </div>
        {/* Fasteners */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("metalFasteners")) || null}
            onChange={(event, value) => updateInputObject("metalFasteners", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Fasteners" />}
          />
        </div>
        {/* Forging */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("metalForging")) || null}
            onChange={(event, value) => updateInputObject("metalForging", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Forging" />}
          />
        </div>
        {/* Casting */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("metalCasting")) || null}
            onChange={(event, value) => updateInputObject("metalCasting", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Casting" />}
          />
        </div>
        {/* Rolling */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("metalRolling")) || null}
            onChange={(event, value) => updateInputObject("metalRolling", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Rolling" />}
          />
        </div>
        {/* Heading */}
        <div className="col-span-full">
          <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3">FABRICATED METAL PRODUCTS</Text>
        </div>
        {/* Pressure Vessels */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("dabMetalPressureVessel")) || null}
            onChange={(event, value) => updateInputObject("dabMetalPressureVessel", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Pressure Vessels" />}
          />
        </div>
        {/* Heat Exchangers */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("dabMetalHeatExchangers")) || null}
            onChange={(event, value) => updateInputObject("dabMetalHeatExchangers", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Heat Exchangers" />}
          />
        </div>
        {/* Columns */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("fabMetalColumns")) || null}
            onChange={(event, value) => updateInputObject("fabMetalColumns", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Columns" />}
          />
        </div>
        {/* Reactors */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("fabMetalReactors")) || null}
            onChange={(event, value) => updateInputObject("fabMetalReactors", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Reactors" />}
          />
        </div>
        {/* Tanks */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("fabMetalTanks")) || null}
            onChange={(event, value) => updateInputObject("fabMetalTanks", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Tanks" />}
          />
        </div>
        {/* Piping */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("fabMetalPiping")) || null}
            onChange={(event, value) => updateInputObject("fabMetalPiping", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Piping" />}
          />
        </div>
        {/* Pipeline */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("fabMetalPipeline")) || null}
            onChange={(event, value) => updateInputObject("fabMetalPipeline", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Pipeline" />}
          />
        </div>
        {/* Structurals */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("fabMetalStructurals")) || null}
            onChange={(event, value) => updateInputObject("fabMetalStructurals", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Structurals" />}
          />
        </div>
        {/* Heading */}
        <div className="col-span-full">
          <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3">MACHINERY & EQUIPMENT</Text>
        </div>
        {/* Pumps */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("machinePumps")) || null}
            onChange={(event, value) => updateInputObject("machinePumps", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Pumps" />}
          />
        </div>
        {/* Valves */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("amchineValvs")) || null}
            onChange={(event, value) => updateInputObject("amchineValvs", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Valves" />}
          />
        </div>
        {/* Compressors */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("machineCompressors")) || null}
            onChange={(event, value) => updateInputObject("machineCompressors", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Compressors" />}
          />
        </div>
        {/* Skids */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("machineSkids")) || null}
            onChange={(event, value) => updateInputObject("machineSkids", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Skids" />}
          />
        </div>
        {/* Heading */}
        <div className="col-span-full">
          <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3">QMS+W3:W116 auditor</Text>
        </div>
        {/* System Auditor */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={qmsAuditor}
            getOptionLabel={(option) => option["label"] || ""}
            value={qmsAuditor.find((item) => item["id"] == getVal("systemAuditor")) || null}
            onChange={(event, value) => updateInputObject("systemAuditor", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="System Auditor" />}
          />
        </div>
        {/* Heading */}
        <div className="col-span-full">
          <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3">REMARK</Text>
        </div>
        {/* Remarks */}
        <div className="w-full">
          <TextFields
            label="Remarks"
            value={getVal("remark")}
            onChange={(e) => updateInputObject("remark", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
        </div>
      </div>
      <div className="flex gap-10 mt-5 justify-end">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.create || permissions.allAccess) && (
          <SaveAndUpdate
            id="btn-add-outline"
            label={params.id == 0 ? "Save" : "Update"}
            onClick={onSubmit}
          />
        )}
      </div>
    </div>
  );
};

export default EditCAMMechanical;